import { Button, Table, Modal } from 'react-bootstrap';
import arrayUtilities from '../../utilities/arrayUtilities';
import { useState } from 'react';
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { WorkflowConfigTypeRow } from './workflowConfigTypeRow';

export const WorkflowConfigTypesTable = ({ containerId, sortingArray, handleAddClick, onEditClick, setConfigTypes, configType, workflowHasData }) => {
    const [deleteIndex, setDeleteIndex] = useState(null)
    const {setNodeRef} = useDroppable({id: containerId})

    const handleDelete = () => {
        const newSortingArray = sortingArray.toSpliced(deleteIndex, 1)
        setConfigTypes(newSortingArray)
        setDeleteIndex(null)
    }

    const handleCopy = (item, index) => {
        const newArray = sortingArray.toSpliced(index + 1, 0, item)
        setConfigTypes(newArray)
    }

    return (
        <Table hover className='workflow-config-table config-types-table'>
            <thead>
                <tr>
                    <th className='px-0'>&nbsp;</th>
                    <th>Name</th>
                    <th>Geometry Type</th>
                    <th className='text-center'>Icon</th>
                    <th className='text-center'>Allow Photos</th>
                    <th className='text-center'>Color</th>
                    <th className='text-end'>
                        <Button variant='secondary' size="sm" onClick={ () => handleAddClick() }>
                            <span className='d-flex align-items-center'><i className='fi-plus me-2'></i>Add</span>
                        </Button>
                    </th>
                </tr>
            </thead>           
            {
                sortingArray && 
                <SortableContext id={`${configType}-droppable-container`} items={sortingArray} strategy={verticalListSortingStrategy}>
                    <tbody ref={setNodeRef}>
                        {
                            !arrayUtilities.isNullOrEmpty(sortingArray) && sortingArray.map(
                                (item, index) => item && <WorkflowConfigTypeRow id={`${configType}-${index}`} key={index} item={item} onEditClick={() => onEditClick(item, index)} onDeleteClick={() => setDeleteIndex(index)} onCopyClick={() => handleCopy(item, index)} />
                            )
                        }
                    </tbody>
                </SortableContext>
            }            
            {
                deleteIndex !== null &&
                <Modal show onHide={ () => setDeleteIndex(null) } centered>
                    <Modal.Header>
                        <Modal.Title>Delete Type</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            workflowHasData 
                            ? <> This workflow has data attached to it. Deleting this entry could lead to loss of data. Please proceed with caution.</>
                            : <>Are you sure?</>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size="sm" variant='secondary' onClick={ () => setDeleteIndex(null) }>Cancel</Button>
                        <Button size="sm" variant="danger" onClick={ () => {
                            handleDelete(deleteIndex)
                            setDeleteIndex(null)
                        } }>Delete</Button>
                    </Modal.Footer>
                </Modal>
            }
        </Table>
    )
}